
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage } from "element-plus";
import type { ElForm } from "element-plus";

type FormInstance = InstanceType<typeof ElForm>;

interface ShippingFeeFormData {
  mode: string;
  threshold: number;
  delivery_fee: number;
  freight_collect: boolean;
}

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("运费配置", ["系统管理"]);
    });

    const formRef = ref<FormInstance>();
    const store = useStore();

    const formData = ref<ShippingFeeFormData>({
      mode: "amount",
      threshold: 100,
      delivery_fee: 15,
      freight_collect: false,
    });

    const rules = ref({
      mode: [{ required: true, message: "请选择免运模式", trigger: "change" }],
      threshold: [{ required: true, message: "请输入免运门槛", trigger: "blur" }],
      delivery_fee: [{ required: true, message: "请输入运费金额", trigger: "blur" }],
    });

    // Load existing config
    store
      .dispatch(Actions.GET_SYSTEM_SETTING, "shipping_fee_config")
      .then(() => {
        const setting = store.getters.currentSystemSetting;
        if (setting && setting.value) {
          try {
            const parsed = JSON.parse(setting.value);
            formData.value = {
              mode: parsed.mode || "amount",
              threshold: Number(parsed.threshold) || 100,
              delivery_fee: Number(parsed.delivery_fee) || 15,
              freight_collect: parsed.freight_collect === true || parsed.freight_collect === "true",
            };
          } catch (e) {
            console.error("Failed to parse shipping config:", e);
          }
        }
      })
      .catch((e: unknown) => {
        console.error(e);
      });

    const onSubmit = (formEl: FormInstance | undefined) => {
      if (!formEl) return;

      formEl.validate((valid) => {
        if (valid) {
          const params = {
            system_setting: {
              key: "shipping_fee_config",
              title: "运费配置",
              value: JSON.stringify(formData.value),
            },
          };

          store
            .dispatch(Actions.UPDATE_SYSTEM_SETTING, params)
            .then(() => {
              ElMessage.success("保存成功");
            })
            .catch((e: unknown) => {
              console.error(e);
              ElMessage.error("保存失败");
            });
        }
      });
    };

    return {
      formRef,
      formData,
      rules,
      onSubmit,
    };
  },
});
